import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ModalDialogService } from 'ngx-modal-dialog';
import * as $ from 'jquery';
import { OrderService } from './services/order-service.service';
import { Observable } from 'rxjs';
import { OrderServiceModel } from './model/order-service.model';

@Component({
    selector: 'app-order-service-component',
    templateUrl: './order-service.component.html',
    styles: ['li.tabs__tab.active { background-color: #52ae32 !important; color: white; }']
})

export class OrderServiceComponent implements OnInit {
    orderServiceResumes: OrderServiceModel[];
    orderServiceResume: object;
    pageSize: number = 5;
    p: number = 1;
    total: number = 40;
    txtSearch: string = "*";
    lastElement: object = null;
    modalService: ModalDialogService;
    viewRef: ViewContainerRef;
    loading: boolean;

    constructor(
      modalService: ModalDialogService, 
      viewRef: ViewContainerRef, 
      private orderService: OrderService
      ) {
        this.modalService = modalService;
        this.viewRef = viewRef;
    }

    ngOnInit() {
        if (!this.loggedUser()) {
            window.location.href = "/authentication";
        }
        this.getOrderServiceResumes(1);
    }

    public doSearch($event: Event) {
        this.txtSearch = ($event.target as HTMLInputElement).value;
        this.p = 1;
      this.getOrderServiceResumes(this.p);
    }

    public doSearchClear() {
        this.txtSearch = "*";
      this.getOrderServiceResumes(this.p);
    }

    public refrehPage() {
      this.getOrderServiceResumes(this.p);
    }

   public getOrderServiceResumes(page) {
      this.loading = true;
      this.orderService.getService(page, this.txtSearch)
      .subscribe(result => {
        try {
          this.loading = false;
          this.orderServiceResumes = result["listOrderServiceResume"];
          this.orderServiceResume = result["listOrderServiceResume"][0];
          this.pageSize = result["pageSize"];
          this.p = result["currentPage"];
          this.total = result["totalRecords"];
        } catch (er) {
          this.loading = false;
          this.orderServiceResumes = [];
          this.orderServiceResume = {};
          this.pageSize = result["pageSize"];
          this.p = 1;
          this.total = result["totalRecords"];
        }
      });
    }

    public setOrderItemService(index) {
        this.orderServiceResume = this.orderServiceResumes[index];
      }

    public openModal(modal, index) {
      document.getElementById(modal).style.display = "block";
      document.getElementById(modal).style.backgroundColor = "rgba(12, 0, 0, 0.5)";

      this.setOrderItemService(index);
    }

    public closeModal(modal) {
      document.getElementById(modal).style.display = "none";
    }

    loggedUser() {
        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser) {
            return true;
        }
    }
}

